import { useState } from "react";
import axios from "./axios";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export const useArenaDeductFee = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(null);
  const [insufficient, setInsufficient] = useState(false);
  const handelDeductFee = async (id, slug, fee) => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        "/audiences/wallet/deduct-fee",
        JSON.stringify({
          game_fee: fee,
        }),
      );

      if (response.status === 200) {
        setIsLoading(false);
        const navigateUrl = `/game-started?slug=${slug?.toLowerCase()}&id=${id}`;
        // Clear problematic session storage flags before navigation
        sessionStorage.removeItem("claimedActive");
        sessionStorage.removeItem("spinGameActive");

        navigate(navigateUrl);
      }
    } catch (err) {
      setIsLoading(false);
      if (err?.response?.data?.message === "insufficient funds") {
        setShow(false);
        setInsufficient(true);
      } else {
        console.error("Error message:", err?.response?.data?.message);
        toast.error(err?.response?.data?.message);
      }
    }
  };
  return {
    handelDeductFee,
    isLoading,
    insufficient,
    setInsufficient,
    show,
    setShow,
  };
};
